export default "__VITE_ASSET__C8i8B97T__"